import { useLocation } from "react-router-dom";
import { Path } from "src/core/paths/paths";

export const useIsPartnersPage = () => {
    const location = useLocation();

    return location.pathname === Path.Partners
}